import { GET } from './api';

const table = 'produtos';

export const getTodos = async () => {
  return await GET(`/${table}`, true);
};
